/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import PanelMessage from 'common/components/PanelMessage';
import { FlexItem, FlexLayout } from '@waca/ca-ui-toolkit';
import EmptyState from 'common/components/EmptyState';
import searchResults128 from '@ba-ui-toolkit/ba-graphics/dist/illustrations-js/search-results_128.js';
import stringResource from 'ba-filter-nls';
import FilterList from './FilterList';
import FilterSearchInput from './FilterSearchInput';
import FilterLoadingSpinner from './FilterLoadingSpinner';

export default class SelectValueFilterPane extends Component<any, any> {
	// Prop definitions
	static propTypes = {
		totalValues: PropTypes.number.isRequired,
		selectedValuesCount: PropTypes.number,
		loading: PropTypes.bool,
		allowSearch: PropTypes.bool.isRequired,
		onClick: PropTypes.func.isRequired,
		// onInvert: PropTypes.func.isRequired,
		// onClear: PropTypes.func.isRequired,
		onSearch: PropTypes.func,
		contentRenderer: PropTypes.func,
		getValue: PropTypes.func.isRequired,
		readOnly: PropTypes.bool,
		hasMoreData: PropTypes.bool,
		isSearching: PropTypes.bool,
	};

	// Define default property values
	static defaultProps = {
		selectedValuesCount: 0,
		loading: false,
		readOnly: false,
		allowSearch: true,
		hasMoreData: false,
		isSearching: false,
	};

	_getValue = index => {
		const { getValue, hasMoreData, totalValues } = this.props;

		if (hasMoreData && index >= totalValues) {
			return {
				id: totalValues,
				caption: stringResource.get('dataTruncation'),
				selectable: false,
			};
		}

		return getValue(index);
	};

	_renderSelectValueFilterPane = () => {
		// TODO add onInvert and onClear
		const {
			loading,
			selectedValuesCount,
			totalValues,
			onSearch,
			onClick,
			contentRenderer,
			readOnly,
			allowSearch,
			hasMoreData,
			isSearching,
		} = this.props;

		return (
			<FlexLayout fullHeight direction="column">
				{allowSearch === true && (
					<FlexItem gutter={0}>
						<FilterSearchInput
							fullWidth
							placeholder={stringResource.get('find')}
							title={stringResource.get('find')}
							value=""
							onChange={onSearch}
							readOnly={readOnly}
						/>
					</FlexItem>
				)}

				<FlexItem grow data-tid="filterListSection">
					{totalValues > 0 ? (
						<FilterList
							loading={loading}
							selectedValuesCount={selectedValuesCount}
							totalValues={hasMoreData ? totalValues + 1 : totalValues}
							onClick={onClick}
							getValue={this._getValue}
							contentRenderer={contentRenderer}
							readOnly={readOnly}
							isSearching={isSearching}
						/>
					) : (
						<PanelMessage topOffset={20}>
							<EmptyState
								icon={searchResults128}
								header={stringResource.get('filter_noSearchResults')}
								body={stringResource.get('filter_tryDifferentTerm')}
							/>
						</PanelMessage>
					)}
				</FlexItem>
			</FlexLayout>
		);
	};

	render() {
		const { loading } = this.props;

		if (loading) {
			return <FilterLoadingSpinner />;
		}

		return this._renderSelectValueFilterPane();
	}
}
